import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'skeleton',
  template: `
    <ng-container [ngSwitch]="moduleType">
      <div *ngSwitchCase="'offerBoxes'" class="eva-3-container -eva-3-skeleton -module-skeleton-{{skeletonIndex}}" [ngClass]="offersQty+'-offers'">

        <div class="-skeleton-row">

          <div class="-skeleton-column -skeleton-column-left">
            <div class="-skeleton-text -skeleton-title-first-line "></div>
            <div class="-skeleton-text -skeleton-title-second-line -eva-3-hide-small"></div>
            <div class="-cap-skeleton">
              <div class="-skeleton-text -skeleton-tooltip"></div>
              <div class="-eva-3-skeleton">
                <i class="-skeleton-circle"></i>
              </div>
            </div>
            <div class="-eva-3-skeleton -btn-skeleton-container -eva-3-hide-small">
              <button class="eva-3-btn-ghost -skeleton-button -md" name="">
                <em class="btn-text -see-more-skeleton"></em>
              </button>
            </div>
          </div>

          <div class="-skeleton-column -skeleton-column-right -eva-3-hide-small">
            <div *ngFor="let offerSkeleton of offerSkeletons" class="-skeleton-filled -offer-skeleton"></div>
          </div>

          <div class="-skeleton-column -skeleton-column-right -eva-3-hide-medium-up">
              <div class="-skeleton-filled -offer-skeleton"></div>
              <div class="-skeleton-filled -partial-offer-skeleton"></div>
          </div>

        </div>
      </div>

      <div *ngSwitchCase="''" class="eva-3-container -eva-3-skeleton -default-skeleton -module-skeleton-{{skeletonIndex}}">
        <div class="-skeleton-text -default-top-skeleton-text"></div>
        <div class="-skeleton-text -default-bottom-skeleton-text"></div>
      </div>

    </ng-container>
  `,
  styleUrls: ['./skeleton.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SkeletonComponent implements OnInit {

  @Input() moduleType: string = '';
  @Input() skeletonIndex?: number = 0;

  @Input() offersQty: number = 3;

  offerSkeletons: Array<any> = [];

  constructor() { }

  ngOnInit(): void {
    this.offerSkeletons = new Array(this.offersQty).fill({})
  }

}
